import {
  HttpHandler,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { inject, Provider } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService
} from '@azure/msal-angular';

import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory
} from '@auth/auth.config';
import { AuthService } from '@auth/services/auth/auth.service';

export const MSAL_INTERCEPTOR: HttpInterceptorFn = (req, next) => {
  const interceptor = inject(MsalInterceptor);

  const handler: HttpHandler = {
    handle: (request: HttpRequest<unknown>) => next(request)
  };

  return interceptor.intercept(req, handler);
};

export const AUTH_PROVIDERS: Provider[] = [
  AuthService,
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory
  },
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService
];
